export const actionPlanTaskFields = `
  id
  conversationThreadsCount
  createdAt
  description
  dueDate
  milestone
  name
  parentTaskId
  previousTaskId
  revision
  status
  updatedAt
  updatedById
  updatedByType
  owners {
    ownerId
    ownerType
  }
  requester {
    email
    firstName
    lastName
    photo
  }
`;
